import { Stack, SxProps, Typography } from "@mui/material";
import { SenecButton } from "src/newsenec-ui-components";

export interface Senec404PageProps {
    title: string;
    description: string;
    buttonMessage: string;
    onButtonClick: () => void;
    /**
     * Page container sx props
     */
    sx?: SxProps;
}

export const Senec404Page = ({ title, description, buttonMessage, onButtonClick, sx }: Senec404PageProps) => {
    return (
        <Stack id="404-page" alignItems="center" justifyContent="center" minHeight="60vh" mx="2rem" my="4rem" sx={sx}>
            <Stack alignItems="start" spacing={1}>
                <Typography variant="h2">{title}</Typography>
                <Typography>{description}</Typography>

                <SenecButton size="small" style={{ marginTop: "2rem" }} onClick={onButtonClick}>
                    {buttonMessage}
                </SenecButton>
            </Stack>
        </Stack>
    );
};
